<template>
  <div>
    <header>
      <head-top></head-top>
      <el-carousel :interval="3000" arrow="always">
        <el-carousel-item>
          <div class="top">
            <div class="wrapper">
              <div class="header-top">
                <div class="left">
                  <img src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/happyAI.png" alt=""
                    class="logo" />
                </div>
                <div class="right">
                  <img src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/ai-pc.jpg" alt=""
                    class="tvFrame" />
                </div>
                <div class="typeWrapper">
                  <div class="type" ref="headType"></div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>

        <!-- <el-carousel-item>
          <div class="banner2">
            <a target="_blank" href="http://s.noc.net.cn/home/zs?c=SCTZ">
              <div class="common">
                <img class="newBanner" src="./../../assets/resource/home/banner/noc-2.png" />
              </div>
            </a>
          </div>
        </el-carousel-item> -->

        <el-carousel-item>
          <div class="banner2">
            <a href="https://paat.ceracu.org.cn/#/home" target="_blank" rel="noopener noreferrer">
              <div class="common">
                <img class="newBanner" src="./../../assets/resource/home/banner/paat1920.jpg" />
                <img class="newlogo" src="./../../assets/resource/home/banner/paatlogo.jpg" />
              </div>
            </a>
          </div>
        </el-carousel-item>

        <!-- <el-carousel-item>
          <div class="banner2">
            <a href="https://ai.istemedu.com/jskx" target="_blank" rel="noopener noreferrer">
              <div class="common">
                <img class="newBanner" src="./../../assets/resource/home/banner/jskx2024.jpg" />
              </div>
            </a>
          </div>
        </el-carousel-item> -->

        <el-carousel-item>
          <div class="banner2">
            <a target="_blank" href="https://nycre.cn/">
              <div class="common">
                <img class="newBanner" src="./../../assets/resource/home/banner/ycre1920-1.jpg" />
              </div>
            </a>
          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner2">
            <router-link :to="{ path: '/activity2020' }"><img class="newBanner"
                src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/lgb/20241218-1.jpg" /></router-link>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="bottom">
        <div class="bottom1">
          <span>{{ $t('Home.text2') }}</span>
          <div>
            <a class="btn1" href="https://aischool.aigcuniversity.com">{{
        $t('Home.entry1')
      }}</a>
            <a class="btn2" href="https://aivip.aigcuniversity.com">{{
          $t('Home.entry2')
        }}</a>
            <a class="btn2" href="https://ainet.aigcuniversity.com">{{
          $t('Home.entry3')
        }}</a>
            <a class="btn2" href="https://aiteacher.aigcuniversity.com">{{
          $t('Home.entry4')
        }}</a>
          </div>
        </div>
      </div>
    </header>
    <article>
      <section id="part-1">
        <div class="title-part">
          <span class="title">{{ $t('Home.AI-1') }}</span>
          <div class="text-main">
            <div class="text-image">
              <img class="img-1" src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/1.jpg" alt="">
              <div class="text-1">2017年国务院印发的《新一代人工智能发展规划》的通知中明确提到“在中小学阶段设置人工智能相关课程，逐步推广编程教育。”</div>
            </div>
            <div class="text-image">
              <div class="text-video" @click="loadHomeVideo" v-if="!homeVideoLoaded">
                <div class="video-placeholder">
                  <img src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/video-img.png" alt="视频封面" />
                  <div class="play-button">▶</div>
                </div>
              </div>
              <div class="text-video" v-else>
                <video poster="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/video-img.png"
                  :src="homeVideoSrc"
                  controls="controls"
                  autoplay>
                  您的浏览器不支持 video 标签。
                </video>
              </div>
              <div class="text-1">
                2024年的全国两会《政府工作报告》中一个新关键词引发热议一“人工智能+”行动。教育部部长怀进鹏表示，把人工智能技术深入到教育教学和管理全过程、全环节，来研究它的有效性、适应性，让青年一代更加主动地学，让教师更加创造性地教。
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="part-2">
        <div class="title-part">
          <span class="title">{{ $t('Home.AI-2') }}</span>
          <div class="grid-container">
            <div v-for="(image, index) in images" :key="index" class="grid-item" @mouseover="addOverlay(index)"
              @mouseleave="removeOverlay(index)">
              <div class="overlay" :class="{ 'full-overlay': index === hoveredIndex }">
                <p class="img-tit">{{ image.title }}</p>
                <p class="img-des">{{ image.description }}</p>
              </div>
              <img :src="image.src" :alt="`Image ${index + 1}`">
            </div>
          </div>
        </div>
      </section>
      <section id="part-3">
        <div class="title-part">
          <span class="title">{{ $t('Home.AI-3') }}</span>
          <div class="grid-container">
            <div class="grid-item" v-for="(item, index) in items" :key="index" @click="handleClick(item, index)">
              <img :src="item.image" :alt="'Image ' + (index + 1)">
              <h3>{{ item.title }}</h3>
              <p class="img-tit1">{{ item.description }}</p>
              <p class="img-tit2" v-if="item.description2">{{ item.description2 }}</p>
            </div>
          </div>
        </div>
      </section>
      <section id="part-4">
        <div class="title-part">
          <span class="title">{{ $t('Home.AI-4') }}</span>
          <div class="container">
            <img class="training"
              src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/%E5%AD%A6%E4%B9%A0%E7%94%9F%E6%B6%AF%E8%A7%84%E5%88%92-%E7%94%9F%E6%88%90%E5%BC%8Fai.jpg"
              alt="">
          </div>
        </div>
      </section>
      <section id="part-5">
        <div class="title-part">
          <span class="title">{{ $t('Home.AI-5') }}</span>
        </div>
        <div class="lists">
          <ul>
            <li v-for="(item, index) in this.userProgress" :key="index">
              <i class="fa fa-ellipsis-h fa-1x"></i>
              <i class="fa fa-ellipsis-h fa-2x"></i>
              <img :src="item.preview_image" alt="" />
              <div class="userProgressfont">{{ processTitle(item.title) }}</div>
              <a :href="'https://cx.istemedu.com' +
        item.preview_path +
        '&u=' +
        item.user_id
        "></a>
            </li>
          </ul>
        </div>
        <div class="bottom">
          <div class="goCommunity" @click="moreDetail">{{
        $t('Home.more')
            }}</div>
        </div>
      </section>
    </article>
    <footer>
      <footer-page></footer-page>
    </footer>
    <div class="floating-box" @click="getChatPath">
      <img src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happycode-aifarmer/doudou.png"
        alt="Floating Box" />
    </div>
  </div>
</template>

<script>
import headTop from '@/components/header/index'
import footerPage from '@/components/footer/index'
import axios from 'axios'
import Typed from 'typed.js'
import headGif from '@/assets/resource/home/headGif.gif'
import { getApplabList } from '@/api/api'

export default {
  data() {
    return {
      homeVideoLoaded: false,
      homeVideoSrc: '',
      hoveredIndex: null,
      userProgress: [],
      message: [],
      show: true,
      screenWidth: document.body.clientWidth,
      typeOptions: {
        strings: [this.$t('Home.AI') + '^1000'],
        typeSpeed: 100,
        fadeOut: true,
        loop: true,
        startDelay: 1000
      },
      images: [
        {
          title: '01 思维锻炼',
          description: '学习人工智能可以培养学生的批判性思维和解决问题的能力，学生需要理解和分析人工智能生成的内容，评估其准确性和相关性，并不断调整提示以获得更好的结果而不是盲从，这锻炼了他们的逻辑思维和分析能力，有助于他们在各学科中解决复杂问题；同时，在学习如何与生成式人工智能交流时，学生分解问题、设计解决问题的任务链过程更培养了计算思维能力。',
          src: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/7.jpg'
        },
        {
          title: '02 培养创新意识',
          description: '人工智能是跨时代的崭新工具，其价值正等待懂他的学生挖掘创造，而此过程也激励学生尝试新的方法和思路。同时，生成式人工智能也具备各个学科的能力，是学生跨学科融合创新的最好助手。',
          src: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/3.jpg'
        },
        {
          title: '03 提升数字素养',
          description: '学习生成式人工智能将提高学生的数据分析、处理和预测能力。掌握生成式人工智能将让学生拥有强大的数字工具，以解决学习、生活中的各类问题。',
          src: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/4.jpg'
        },
        {
          title: '04 提高全科学习能力',
          description: '掌握生成式人工智能，学生能随时毫无心理压力的与他探讨解题思路甚至研究十万个为什么，养成研究型人格；他也能够根据学生的基础给予个性化的培养方案，提高学生学习兴趣和效率。',
          src: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/2.jpg'
        },
        {
          title: '05 增强对社会责任的理解',
          description: '学习生成式人工智能的应用和影响，学生可以理解科技对社会的作用和责任。讨论人工智能的伦理问题和社会影响，可以培养他们的社会责任感和道德判断力，使他们在未来的科技应用中更加负责任和有道德。',
          src: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/6.jpg'
        },
        {
          title: '06 面向未来',
          description: '新一代人工智能技术是国家最重视的科技领域。国家也对这方面有特长的孩子，提供了更广的科技特长生升学路径。掌握人工智能技术也将为学生未来的职业发展提供更多机会，也是国家竞争力的体现。',
          src: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/5.jpg'
        }
      ],
      items: [
        { image: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/9.jpg', title: '参与标准制定', description: '教育通用人工智能大模型标准', description2: '参与单位' },
        { image: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/8.jpg', title: '支持教育部白名单国赛', description: 'NOC大赛AI生成创新挑战赛', description2: '技术支持平台' },
        { image: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/10.jpg', title: '师资培训&教师竞赛', description: '生成式人工智能教师培训竞赛', description2: '技术支持单位' },
        { image: 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/11.jpg', title: '学生课程', description: '在国内千余所学校开设课程' }
      ],
      headGif
    }
  },
  components: {
    headTop,
    footerPage
  },
  created() {
    this.applabList()
    this.$http.get('../../../static/bbb.json').then(
      res => {
        this.message = res.data.aaa.reduce((prev, cur) => {
          if (cur.column === '“畅”谈') {
            if (prev.length <= 3) {
              prev.push(cur)
            }
          } else if (cur.column === '“畅”响') {
            if (prev.length <= 1) {
              prev.push(cur)
            }
          } else if (cur.column === '“畅”达') {
            if (prev.length <= 5) {
              prev.push(cur)
            }
          }
          return prev
        }, [])
        // let dataone = []
        // let datatwo = []
        // let datathre = []
        // res.data.aaa.filter(item => {
        //   if (item.column === '“畅”响') {
        //     dataone.push(item)
        //   } else if (item.column === '“畅”谈') {
        //     datatwo.push(item)
        //   } else {
        //     datathre.push(item)
        //   }
        // })
        // dataone = dataone.splice(0, 2)
        // datatwo = datatwo.splice(0, 2)
        // datathre = datathre.splice(0, 2)
        // this.message = datathre.concat(dataone, datatwo)
      },
      res => { }
    )
    this.$nextTick(() => {
      this.zoomCourse(this.screenWidth)
    })
    this.play()
  },
  watch: {
    screenWidth(val) {
      this.screenWidth = val
      this.zoomCourse(val)
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    this.$nextTick(() => {
      this.Typed = new Typed(this.$refs.headType, this.typeOptions)
    })
  },
  methods: {
    loadHomeVideo() {
      this.homeVideoSrc = 'https://istem-other-files.oss-cn-shanghai.aliyuncs.com/happyAI/%E6%95%99%E8%82%B2%E9%83%A8%E6%80%80%E9%83%A8%E9%95%BF%E5%8F%91%E8%A8%80.mp4'
      this.homeVideoLoaded = true
    },
    addOverlay(index) {
      this.hoveredIndex = index
      console.log(index, 'index')
    },
    moreDetail() {
      window.open('http://cx.istemedu.com/chatHome/gpts/discovery?explore=1', '_blank')
    },
    getChatPath() {
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobile = /mobile|android|iphone|ipad|phone/i.test(userAgent)
      if (isMobile) {
        window.open('https://cx.istemedu.com/chatHome/mobileChat', '_blank')
      } else {
        window.open('https://cx.istemedu.com/chatHome/gpts/discovery', '_blank')
      }
    },
    processTitle(title) {
      if (title.includes('(')) {
        const lastOpenParenIndex = title.lastIndexOf('(')
        title = title.substring(0, lastOpenParenIndex)
      }
      return title
    },
    applabList() {
      const data = {
        currentPage: 1,
        perPage: 9,
        type: 'gpt',
        order: 'score desc'
      }
      getApplabList(data).then(res => {
        console.log(res, 'rrrrrr')
        this.userProgress = res.data.body.splice(0, 4)
      })
    },
    handleClick(item, index) {
      console.log('Clicked item:', item)
      console.log('Item index:', index)
      if (index === 0) {
        window.open('http://blog.istemedu.com/archives/2134', '_blank')
      } else if (index === 1) {
        window.open('http://blog.istemedu.com/archives/2119', '_blank')
      } else if (index === 2) {
        window.open('http://blog.istemedu.com/archives/2109', '_blank')
      } else if (index === 3) {
        window.open('/coop/case', '_blank')
      }
    },
    removeOverlay() {
      this.hoveredIndex = null
    },
    autoPlay() {
      this.show = !this.show
    },
    play() {
      setInterval(this.autoPlay, 500)
    },
    zoomCourse(val) {
      let trackDom = document.querySelector('.track')
      let result = parseFloat(val / 960)
      if (result <= 1) {
        trackDom.style.zoom = result
        // trackDom.style.transform = 'scale(' + result + ')'
        trackDom.style.left = 'calc(50% - 480px)'
      } else {
        trackDom.style.left = '0'
      }

      let courseListDom = document.querySelector('#courseList')
      let result1 = parseFloat(val / 700)
      if (result1 <= 1) {
        courseListDom.style.transform = 'scale(' + result1 + ')'
        courseListDom.style.left = 'calc(50% - 350px)'
      } else {
        courseListDom.style.left = '0'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
article {
  max-width: 1920px;
  margin: 0 auto;
}

.floating-box {
  position: fixed;
  right: 180px;
  bottom: 180px;
  width: 50px;
  height: 50px;
  z-index: 9999;
  cursor: pointer;

  img {
    width: 400%;
  }
}

.floating-box:hover {
  opacity: 0.8;
}

/* 大于等于975px的样式 */
@media (min-width: 975px) {
  .userProgressfont {
    text-align: center;
    margin-top: -9px;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 4px;
  }

  #part-1 {
    background: #e7e7e7;

    .title-part {
      .title {
        display: block;
        width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 30px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 0px 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);
          user-select: text;

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
            cursor: pointer;
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            line-height: 1.8;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            line-height: 1.2;
          }
        }

        .text-video {
          margin: 0 auto;
          display: block;
          position: relative;
          cursor: pointer;

          video {
            width: 140px;
            height: 220px;
          }

          .video-placeholder {
            position: relative;
            width: 140px;
            height: 220px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .play-button {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 50px;
              height: 50px;
              background: rgba(0, 0, 0, 0.6);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-size: 20px;
              transition: all 0.3s;
            }

            &:hover .play-button {
              background: rgba(0, 0, 0, 0.8);
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        .title-text {
          display: inline-block;
          line-height: 30px;
          width: 585px;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 14px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-2 {
    // height: 594px;
    background: #fff;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        display: block;
        width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .grid-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0;
        padding: 30px 0px;
        cursor: pointer;
        width: 82%;
        margin: 0 auto;
      }

      .grid-item {
        position: relative;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 10px;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        text-align: left;
        user-select: text;
      }

      .full-overlay {
        background: rgba(0, 0, 0, 0.5);
        height: 100%;
      }

      .img-tit {
        font-size: 24px;
        font-weight: bold;
        padding-left: 8px;
      }

      .img-des {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s ease-in-out;
        font-size: 15px;
        letter-spacing: 2px;
        padding-left: 8px;
        padding-top: 12px;
      }

      .grid-item:hover .img-des {
        position: absolute;
        top: 44px;
        left: 0;
        width: 100%;
        visibility: visible;
        opacity: 1;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.8;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 14px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-3 {
    // height: 594px;
    background: #e7e7e7;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        display: block;
        width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .grid-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 30px 0px;
        width: 82%;
      }

      .grid-item {
        width: 23%;
        background-color: #f9f9f9;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        transform-origin: center;
        user-select: text;
      }

      .grid-item img {
        width: 90%;
        padding: 12px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }

      .grid-item h3 {
        margin: 0px 0px 10px 0px;
        font-weight: bold;

        .circle {
          width: 12px;
          height: 12px;
          background-color: orange;
          border-radius: 50%;
          margin-right: 10px;
          display: inline-block;
        }
      }

      .img-tit1 {
        margin: 8px 10px 2px 10px;
        color: #666;
      }

      .img-tit2 {
        margin: 2px 10px 16px 10px;
        color: #666;
      }

      .grid-item:hover {
        transform: scale(1.1);
        cursor: pointer;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.8;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 30px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-4 {
    // height: 594px;
    background: #fff;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        display: block;
        width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .container {
        display: flex;
        margin: 20px 0px;
        width: 90%;

        .training {
          width: 100%;
        }
      }

      .grid-item {
        width: 23%;
        background-color: #f9f9f9;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        margin-bottom: 20px;
        transform-origin: center;
        user-select: text;
      }

      .grid-item img {
        width: 90%;
        padding: 12px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }

      .grid-item h3 {
        margin: 0px 0px 10px 0px;
        font-weight: bold;

        .circle {
          width: 12px;
          height: 12px;
          background-color: orange;
          border-radius: 50%;
          margin-right: 10px;
          display: inline-block;
        }
      }

      .img-tit1 {
        margin: 8px 10px 2px 10px;
        color: #666;
      }

      .img-tit2 {
        margin: 2px 10px 16px 10px;
        color: #666;
      }

      .grid-item:hover {
        transform: scale(1.1);
        cursor: pointer;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.8;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 30px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-5 {
    max-width: 1920px;
    height: auto;
    background: url(./../../assets/resource/home/community-bg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title-part {

      .title {
        display: block;
        width: 975px;
        font-size: 1.875rem;
        color: #f6ac1d;
        border-bottom: 2px solid #f6ac1d;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }
    }

    .lists {
      margin: 0 auto;
      width: 82%;

      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        // margin-left: 21px;
        margin-top: 40px;

        li {
          width: 270px;
          height: 254px;
          box-sizing: border-box;
          border-top: 20px solid #f1c118;
          border-bottom: 20px solid #f1c118;
          background: #fff;
          // margin-right: 20px;
          margin-bottom: 36px;
          position: relative;

          //edit by wuxianbiao
          // flex: 1;
          .fa-2x {
            position: absolute;
            top: -24px;
            left: 13px;
          }

          .fa-1x {
            display: none;
          }

          img {
            width: 192px;
            height: 192px;
            margin: 12px 40px;
            object-fit: cover;
            object-position: right 0px bottom 0px;
            // edit by wuxianbiao
          }

          span {
            color: #fff;
            margin-top: 20px;
            display: inline-block;
          }

          a {
            position: absolute;
            height: 270px;
            width: 250px;
            top: -20px;
            left: 0px;
          }
        }
      }
    }

    .bottom {
      padding-bottom: 20px;

      .goCommunity {
        font-size: 1.1rem;
        background: #f6ac1d;
        // width: 100px;
        // line-height: 30px;
        text-align: center;
        display: block;
        margin: 0 auto;
        border-radius: 30px;
        // edit by wuxianbiao
        margin-top: 8px;
        margin-bottom: 5px;
        padding: 8px 50px;
        cursor: pointer;
      }
    }
  }
}

/* 750px <= 尺寸 < 975px */
@media (min-width: 750px) and (max-width: 975px) {
  .userProgressfont {
    text-align: center;
    margin-top: -9px;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 4px;
  }

  #part-1 {
    // height: 594px;
    background: #e7e7e7;

    .title-part {
      .title {
        display: block;
        // width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 30px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 0px 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);
          user-select: text;

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
            cursor: pointer;
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.4;
            font-size: 14px;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 14px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-2 {
    // height: 594px;
    background: #fff;

    .title-part {
      .title {
        display: block;
        // width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
        width: 100%;
      }

      .grid-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0;
        padding: 30px 0px;
        cursor: pointer;
        width: 82%;
        margin: 0 auto;
      }

      .grid-item {
        position: relative;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 10px;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        text-align: left;
        user-select: text;
      }

      .full-overlay {
        background: rgba(0, 0, 0, 0.5);
        height: 100%;
      }

      .img-tit {
        font-size: 14px;
        font-weight: bold;
        padding-left: 8px;
      }

      .img-des {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s ease-in-out;
        font-size: 10px;
        letter-spacing: 1px;
        padding-left: 8px;
        padding-top: 12px;
      }

      .grid-item:hover .img-des {
        position: absolute;
        top: 44px;
        left: 0;
        visibility: visible;
        opacity: 1;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.4;
            font-size: 14px;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 14px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-3 {
    // height: 594px;
    background: #e7e7e7;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        display: block;
        // width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .grid-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 30px 0px;
        width: 82%;
      }

      .grid-item {
        width: 23%;
        background-color: #f9f9f9;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        transform-origin: center;
        user-select: text;
      }

      .grid-item img {
        width: 90%;
        padding: 12px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }

      .grid-item h3 {
        margin: 0px 0px 10px 0px;
        font-weight: bold;

        .circle {
          width: 12px;
          height: 12px;
          background-color: orange;
          border-radius: 50%;
          margin-right: 10px;
          display: inline-block;
        }
      }

      .img-tit1 {
        margin: 8px 10px 2px 10px;
        color: #666;
      }

      .img-tit2 {
        margin: 2px 10px 16px 10px;
        color: #666;
      }

      .grid-item:hover {
        transform: scale(1.1);
        cursor: pointer;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.4;
            font-size: 14px;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 30px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-4 {
    // height: 594px;
    background: #fff;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        display: block;
        // width: 975px;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .container {
        display: flex;
        margin: 20px 0px;
        width: 90%;

        .training {
          width: 100%;
        }
      }

      .grid-item {
        width: 23%;
        background-color: #f9f9f9;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        margin-bottom: 20px;
        transform-origin: center;
        user-select: text;
      }

      .grid-item img {
        width: 90%;
        padding: 12px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }

      .grid-item h3 {
        margin: 0px 0px 10px 0px;
        font-weight: bold;

        .circle {
          width: 12px;
          height: 12px;
          background-color: orange;
          border-radius: 50%;
          margin-right: 10px;
          display: inline-block;
        }
      }

      .img-tit1 {
        margin: 8px 10px 2px 10px;
        color: #666;
      }

      .img-tit2 {
        margin: 2px 10px 16px 10px;
        color: #666;
      }

      .grid-item:hover {
        transform: scale(1.1);
        cursor: pointer;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.4;
            font-size: 14px;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 30px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-5 {
    max-width: 1920px;
    height: auto;
    background: url(./../../assets/resource/home/community-bg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title-part {
      width: 100%;

      .title {
        display: block;
        // width: 975px;
        font-size: 1.875rem;
        color: #f6ac1d;
        border-bottom: 2px solid #f6ac1d;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }
    }

    .lists {
      width: 88%;
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        // margin-left: 21px;
        margin-top: 40px;

        li {
          width: 230px;
          height: 210px;
          box-sizing: border-box;
          border-top: 20px solid #f1c118;
          border-bottom: 20px solid #f1c118;
          background: #fff;
          // margin-right: 20px;
          margin-bottom: 36px;
          position: relative;

          //edit by wuxianbiao
          // flex: 1;
          .fa-2x {
            position: absolute;
            top: -24px;
            left: 13px;
          }

          .fa-1x {
            display: none;
          }

          img {
            width: 150px;
            height: 150px;
            margin: 12px 40px;
            object-fit: cover;
            object-position: right 0px bottom 0px;
            // edit by wuxianbiao
          }

          span {
            color: #fff;
            margin-top: 20px;
            display: inline-block;
          }

          a {
            position: absolute;
            height: 210px;
            width: 250px;
            top: -20px;
            left: 0px;
          }
        }
      }
    }

    .bottom {
      padding-bottom: 20px;

      .goCommunity {
        font-size: 1.1rem;
        background: #f6ac1d;
        // width: 100px;
        // line-height: 30px;
        text-align: center;
        display: block;
        margin: 0 auto;
        border-radius: 30px;
        // edit by wuxianbiao
        margin-top: 8px;
        margin-bottom: 5px;
        cursor: pointer;
        padding: 8px 50px;
      }
    }
  }
}

/* 小于750px的样式 */
@media (max-width: 749px) {
  .userProgressfont {
    text-align: center;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 4px;
  }

  #part-1 {
    background: #e7e7e7;

    .title-part {
      .title {
        display: block;
        width: 100%;
        font-size: 18px;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 16px;
        padding-bottom: 8px;
        font-weight: bold;
      }

      .text-main {
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;

        .text-image {
          width: 90%;
          height: auto;
          margin: 10px auto;
          border-radius: 16px;
          background-color: #fff;
          padding: 10px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 100%;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1,
          .text-2 {
            padding: 10px;
            text-indent: 2em;
            line-height: 1.4;
            font-size: 16px;
          }
        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 100%;
            height: auto;
          }
        }
      }

      .title-name {
        width: 100%;
        margin-top: 10px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 10px auto;

        .title-text {
          display: inline-block;
          line-height: 30px;
          width: 100%;
          color: #595757;
        }
      }

      .title-text2 {
        width: 100%;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 10px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 100%;
      height: auto;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 14px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-2 {
    // height: 594px;
    background: #fff;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        display: block;
        width: 100%;
        font-size: 18px;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 20px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .grid-container {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 0;
        padding: 30px 0px;
        cursor: pointer;
        width: 82%;
      }

      .grid-item {
        position: relative;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 10px;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        text-align: left;
        user-select: text;
      }

      .full-overlay {
        background: rgba(0, 0, 0, 0.5);
        height: 100%;
      }

      .img-tit {
        font-size: 24px;
        font-weight: bold;
        padding-left: 8px;
      }

      .img-des {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s ease-in-out;
        font-size: 14px;
        letter-spacing: 2px;
        padding-left: 8px;
        padding-top: 12px;
      }

      .grid-item:hover .img-des {
        position: absolute;
        top: 44px;
        left: 0;
        visibility: visible;
        opacity: 1;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 14px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-3 {
    // height: 594px;
    background: #e7e7e7;

    .title-part {
      .title {
        display: block;
        // width: 975px;
        font-size: 18px;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .grid-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 20px 0px;
      }

      .grid-item {
        width: 90%;
        margin: 1%;
        background-color: #f9f9f9;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        transform-origin: center;
        user-select: text;
      }

      .grid-item img {
        width: 90%;
        padding: 12px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }

      .grid-item h3 {
        margin: 0px 0px 10px 0px;
        font-weight: bold;
        font-size: 20px;

        .circle {
          width: 12px;
          height: 12px;
          background-color: orange;
          border-radius: 50%;
          margin-right: 10px;
          display: inline-block;
        }
      }

      .img-tit1 {
        margin: 8px 10px 2px 10px;
        font-size: 14px;
        color: #666;
      }

      .img-tit2 {
        margin: 2px 10px 16px 10px;
        font-size: 14px;
        color: #666;
      }

      .grid-item:hover {
        transform: scale(1.1);
        cursor: pointer;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 30px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-4 {
    // height: 594px;
    background: #fff;

    .title-part {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        display: block;
        width: 100%;
        font-size: 1.875rem;
        color: #092f55;
        border-bottom: 2px solid #edae24;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }

      .container {
        display: flex;
        margin: 20px 0px;
        width: 90%;

        .training {
          width: 100%;
        }
      }

      .grid-item {
        width: 23%;
        background-color: #f9f9f9;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        margin-bottom: 20px;
        transform-origin: center;
        user-select: text;
      }

      .grid-item img {
        width: 90%;
        padding: 12px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }

      .grid-item h3 {
        margin: 0px 0px 10px 0px;
        font-weight: bold;

        .circle {
          width: 12px;
          height: 12px;
          background-color: orange;
          border-radius: 50%;
          margin-right: 10px;
          display: inline-block;
        }
      }

      .img-tit1 {
        margin: 8px 10px 2px 10px;
        color: #666;
      }

      .img-tit2 {
        margin: 2px 10px 16px 10px;
        color: #666;
      }

      .grid-item:hover {
        transform: scale(1.1);
        cursor: pointer;
      }

      .text-main {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;

        .text-image {
          width: 40%;
          height: 270px;
          margin: 10px;
          border-radius: 16px;
          background-color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 30px;
          box-shadow: 0px 0px 8px rgba(51, 51, 51, 0.3);

          .img-1 {
            width: 188px;
            box-shadow: 0px 0px 12px rgba(51, 51, 51, 0.3);
          }

          .text-1 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1;
          }

          .text-2 {
            padding: 30px;
            text-indent: 2em;
            /* 设置首行缩进 */
            line-height: 1.2;
          }

        }

        .text-video {
          margin: 0 auto;
          display: block;

          video {
            width: 140px;
            height: 220px;
          }
        }
      }

      .title-name {
        width: 585px;
        margin-top: 26px;
        color: #092f55;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;

        // margin-bottom: 0px;
        .title-text {
          display: inline-block;
          // letter-spacing:6px;
          line-height: 30px;
          width: 585px;
          // text-align: center;
          color: #595757;
        }
      }

      .title-text2 {
        width: 669px;
        color: #595757;
        word-wrap: break-word;
        word-break: break-all;
        display: block;
        margin: 26px auto;
        margin-top: 2px;
      }
    }

    .video-part {
      width: 587px;
      height: 326px;
      margin: 0 auto;
      display: block;

      video {
        height: 100%;
      }
    }

    .more {
      width: 100%;
      padding-bottom: 30px;

      .wrapper {
        display: block;
        font-size: 0.6rem;
        background: #f6ac1d;
        width: 100px;
        line-height: 19px;
        text-align: center;
        margin: 30px auto;
        margin-bottom: 0px;
        border-radius: 10px;
      }
    }
  }

  #part-5 {
    max-width: 1920px;
    height: auto;
    background: url(./../../assets/resource/home/community-bg.png) no-repeat;
    background-size: 100% 100%;
    // display: flex;
    // flex-direction: column;
    // align-items: center;

    .title-part {
      width: 100%;

      .title {
        display: block;
        width: 100%;
        font-size: 1.875rem;
        color: #f6ac1d;
        border-bottom: 2px solid #f6ac1d;
        margin: 0 auto;
        text-align: center;
        padding-top: 36px;
        padding-bottom: 13px;
        font-weight: bold;
      }
    }

    .lists {
      width: 100%;
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        // margin-left: 21px;
        margin-top: 40px;
        // padding: 0px 82px;

        li {
          width: 230px;
          height: 210px;
          box-sizing: border-box;
          border-top: 20px solid #f1c118;
          border-bottom: 20px solid #f1c118;
          background: #fff;
          // margin-right: 20px;
          margin-bottom: 36px;
          position: relative;

          //edit by wuxianbiao
          // flex: 1;
          .fa-2x {
            position: absolute;
            top: -24px;
            left: 13px;
          }

          .fa-1x {
            display: none;
          }

          img {
            width: 150px;
            height: 150px;
            margin: 9px 40px;
            object-fit: cover;
            object-position: right 0px bottom 0px;
            // edit by wuxianbiao
          }

          span {
            color: #fff;
            margin-top: 20px;
            display: inline-block;
          }

          a {
            position: absolute;
            height: 210px;
            width: 250px;
            top: -20px;
            left: 0px;
          }
        }
      }
    }

    .bottom {
      padding-bottom: 20px;

      .goCommunity {
        font-size: 14px;
        background: #f6ac1d;
        width: 140px;
        // line-height: 30px;
        text-align: center;
        display: block;
        margin: 0 auto;
        border-radius: 30px;
        // edit by wuxianbiao
        margin-top: 8px;
        margin-bottom: 5px;
        cursor: pointer;
        padding: 8px;
      }
    }
  }
}

.bottomssss {
  font-size: 24px;
  background: #162d55;
  width: 160px;
  line-height: 45px;
  text-align: center;
  display: block;
  margin-left: 51px;
  border-radius: 10px;
  margin-top: 45px;

  a {
    color: #fff;
  }
}

@media screen and (min-width: 500px) {
  header {
    height: 550px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #fff;

    .top {
      width: 100%;
      background: #edae24;
      height: 340px;

      .wrapper {
        max-width: 1920px;
        margin: 0 auto;

        .header-top {
          width: 100%;
          height: 340px;
          background: #edae24;
          position: relative;

          .left {
            float: left;
            width: 50%;
            height: 100%;

            .logo {
              display: block;
              margin: 0 auto;
              max-width: 100%;
              padding-top: 50px;
            }
          }

          .right {
            float: left;
            width: 50%;
            height: 100%;

            .tvFrame {
              display: block;
              box-sizing: border-box;
              max-height: 118%;
              // margin: 0 auto;
              margin-top: -27px;
              margin-left: 130px;
              max-width: 436px;
            }
          }

          div.typeWrapper {
            position: absolute;
            top: 245px;
            left: calc(50% - 362px);

            div.type {
              display: inline;
              font-size: 1.75rem;
              color: #0c2f54;
              line-height: 1.6875rem;
            }
          }
        }

        .header-bottom {
          height: 166px;
        }
      }
    }

    .carouselImg {
      width: 100%;
    }

    .bottom {
      // overflow: -webkit-paged-y;
      height: 100px;

      .bottom1 {
        width: 100%;
        // height: 166px;
        background: #162d55;
        display: inline-block;

        span {
          display: block;
          color: #f6ac1d;
          font-size: 1.24rem;
          line-height: 1.3125rem;
          padding-top: 22px;
          text-align: center;
          border-bottom: 1px solid #f6ac1d;
          margin: 0 auto;
          padding-bottom: 12px;
        }

        div {
          display: flex;
          justify-content: center;
          margin-top: 29px;
          padding-bottom: 26px;

          .btn1 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 0px;
            border-radius: 12px;
            font-size: 24px;
            width: 160px;
            text-align: center;

            &:hover {
              color: #162d55;
              background: #f6ac1d;
            }
          }

          .btn2 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 0px;
            border-radius: 12px;
            font-size: 22px;
            margin-left: 30px;
            width: 160px;
            text-align: center;

            &:hover {
              color: #162d55;
              background: #f6ac1d;
            }
          }
        }
      }
    }

    .banner2 {
      height: 100%;
      background-size: 100% 100%;
      position: relative;

      a {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }

        .newxxx {
          height: 100%;
          width: 100%;
        }

        .common {
          height: 100%;

          .newlogo {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 5%;
            width: 140px;
            height: 140px;
          }

          .newfirstlogo {
            position: absolute;
            left: 14%;
            // transform: translateX(-50%);
            top: 15%;
            width: 80px;
            height: 80px;
          }

          .newBanner {
            height: 100%;
            width: 100%;
          }

          .box {
            position: absolute;
            left: calc(50% - 200px);
            top: 50%;
            transform: translate(calc(-50% + 200px), -50%);

            span {
              display: none;
            }
          }

          .banner-parts {
            position: absolute;
            bottom: -3px;
            left: calc(50% + 21rem);
          }
        }
      }
    }
  }

  .slide-arrow1-leave-active,
  .slide-arrow2-leave-active,
  .slide-arrow3-leave-active,
  .slide-arrow4-leave-active,
  .slide-arrow5-leave-active,
  .slide-arrow6-leave-active,
  .slide-arrow0-leave-active,
  .slide-arrow7-leave-active {
    transition: all 0.5s ease;
  }

  .slide-arrow1-leave-to {
    transform: translate(60px, -20px);
    opacity: 0;
  }

  .slide-arrow2-leave-to {
    transform: translate(-80px, -38px);
    opacity: 0;
  }

  .slide-arrow3-leave-to {
    transform: translate(50px, -10px);
    opacity: 0;
  }

  .slide-arrow4-leave-to {
    transform: translate(45px, -9px);
    opacity: 0;
  }

  .slide-arrow5-leave-to {
    transform: translate(60px, 15px);
    opacity: 0;
  }

  .slide-arrow6-leave-to {
    transform: translate(60px, -12px);
    opacity: 0;
  }

  .slide-arrow0-leave-to {
    transform: translate(80px, -17px);
    opacity: 0;
  }

  .slide-arrow7-leave-to {
    transform: translate(130px, -30px);
    opacity: 0;
  }
}

@media screen and (max-width: 500px) {
  div.typeWrapper {
    position: absolute;
    top: 155px;
    left: calc(50% - 176px);

    div.type {
      display: inline;
      font-size: 0.8rem;
      color: #0c2f54;
      line-height: 1.6875rem;
    }
  }

  header {
    height: auto;
    margin-top: 0px;
    background: #edae24;

    .top {
      width: 100%;
      background: #edae24;
      height: 210px;

      .header-top {
        width: 100%;
        height: 210px;
        background: #edae24;
        position: relative;

        .left {
          float: left;
          width: 50%;
          height: 100%;

          .logo {
            display: block;
            margin: 0 auto;
            max-width: 100%;
            padding-top: 50px;
          }
        }

        .right {
          float: left;
          width: 50%;
          height: 100%;
          position: relative;

          .tvFrame {
            display: block;
            width: 180px;
            position: absolute;
            bottom: 0px;
            left: calc(50% - 90px);
          }
        }

        .showGif-box {
          position: relative;
          height: 100px;
          width: 100px;
          padding: 10px;
          -webkit-perspective: 885;
          margin-left: calc(75% - 134px);
          padding-top: 67px;

          .showGif-wrapper {
            position: absolute;
            height: 112px;
            width: 240px;
            -webkit-transform: rotateY(298deg) rotateX(37deg) rotateZ(-16deg);
            transform: rotateY(291deg) rotateX(29deg) rotateZ(-13deg);

            .showGif {
              width: 100%;
              height: 100%;
            }
          }
        }

        span {
          position: absolute;
          top: 150px;
          font-size: 15px;
          left: calc(50% - 180px);
          bottom: 16px;
          color: #0c2f54;
          line-height: 1.6875rem;
        }
      }
    }

    .bottom {

      // overflow: -webkit-paged-y;
      .bottom1 {
        width: 100%;
        // height: 166px;
        background: #162d55;
        display: inline-block;

        span {
          display: block;
          color: #f6ac1d;
          /* font-size: 1.24rem; */
          line-height: 1.3125rem;
          padding-top: 22px;
          text-align: center;
          border-bottom: 1px solid #f6ac1d;
          /* width: 819px; */
          margin: 0 auto;
          padding-bottom: 12px;
        }

        div {
          display: flex;
          justify-content: center;
          padding-bottom: 26px;

          .btn1 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 24px;
            border-radius: 12px;
            margin-top: 29px;
          }

          .btn2 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 22px;
            border-radius: 12px;
            margin-top: 29px;
            margin-left: 10px;
          }
        }
      }
    }

    .banner2 {
      height: 210px;
      background-size: 100% 100%;
      position: relative;

      a {
        width: 100%;
        height: 100%;

        .newxxx {
          height: 100%;
          width: 100%;
        }

        .common {
          height: 100%;

          .newfirstlogo {
            position: absolute;
            left: 8%;
            top: 15%;
            width: 40px;
            height: 40px;
          }

          .newlogo {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 5%;
            width: 80px;
            height: 80px;
          }

          .newBanner {
            height: 100%;
            width: 100%;
          }

          .box {
            position: absolute;
            left: calc(50% - 200px);
            top: 50%;
            transform: translate(calc(-50% + 200px), -50%);

            span {
              display: none;
            }
          }

          .banner-parts {
            position: absolute;
            bottom: -3px;
            left: calc(50% + 21rem);
          }
        }
      }
    }
  }

  .slide-arrow1-leave-active,
  .slide-arrow2-leave-active,
  .slide-arrow3-leave-active,
  .slide-arrow4-leave-active,
  .slide-arrow5-leave-active,
  .slide-arrow6-leave-active,
  .slide-arrow0-leave-active,
  .slide-arrow7-leave-active {
    transition: all 0.5s ease;
  }

  .slide-arrow1-leave-to {
    transform: translate(60px, -20px);
    opacity: 0;
  }

  .slide-arrow2-leave-to {
    transform: translate(-80px, -38px);
    opacity: 0;
  }

  .slide-arrow3-leave-to {
    transform: translate(50px, -10px);
    opacity: 0;
  }

  .slide-arrow4-leave-to {
    transform: translate(45px, -9px);
    opacity: 0;
  }

  .slide-arrow5-leave-to {
    transform: translate(60px, 15px);
    opacity: 0;
  }

  .slide-arrow6-leave-to {
    transform: translate(60px, -12px);
    opacity: 0;
  }

  .slide-arrow0-leave-to {
    transform: translate(80px, -17px);
    opacity: 0;
  }

  .slide-arrow7-leave-to {
    transform: translate(130px, -30px);
    opacity: 0;
  }
}

@media screen and (min-width: 500px) and (max-width: 975px) {
  header {
    height: 550px;

    .right {
      float: left;
      width: 50%;
      height: 100%;
      position: relative;

      .tvFrame {
        width: 300px;
        position: absolute;
        bottom: 0px;
        left: calc(50% - 250px);
      }
    }

    .showGif-box {
      position: relative;
      height: 200px;
      width: 200px;
      padding: 10px;
      -webkit-perspective: 985;
      margin-left: calc(75% - 171px);
      padding-top: 93px;

      .showGif-wrapper {
        position: absolute;
        height: 200px;
        width: 310px;
        -webkit-transform: rotateY(298deg) rotateX(37deg) rotateZ(-16deg);
        transform: rotateY(300deg) rotateX(37deg) rotateZ(-17deg);

        .showGif {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media screen and (min-width: 975px) {
  header {
    .right {
      float: left;
      width: 50%;
      height: 100%;
      position: relative;

      .tvFrame {
        display: block;
        box-sizing: border-box;
        max-height: 100%;
        margin: 0 auto;
      }
    }

    .showGif-box {
      position: relative;
      height: 200px;
      width: 200px;
      padding: 10px;
      -webkit-perspective: 985;
      margin-left: calc(75% - 215px);
      padding-top: 29px;

      .showGif-wrapper {
        position: absolute;
        height: 253px;
        width: 386px;
        transform: rotateY(298deg) rotateX(37deg) rotateZ(-16deg);

        .showGif {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue